import React from 'react'

import { GameId, isStoreOfferProduct, ProductV2 } from '@common'
import cx from 'classnames'
import Link from 'next/link'
import { useTranslations } from 'next-intl'

import { getRibbonsFromTags } from '@/features/storefronts/_storeBase/card/v2/OfferCard'
import { Ribbon } from '@/features/storefronts/_storeBase/card/v2/OfferCard/shared/Ribbons'
import { BrawlPdpProductHero } from '@/features/storefronts/_storeBase/productPage/v2/games/brawlstars/PdpProductHero'
import { ClashPdpProductHero } from '@/features/storefronts/_storeBase/productPage/v2/games/clashofclans/PdpProductHero'
import { SquadPdpProductHero } from '@/features/storefronts/_storeBase/productPage/v2/games/squadbusters/PdpProductHero'
import { PdpProductHeroHeader } from '@/features/storefronts/_storeBase/productPage/v2/ProductHeroHeader'
import { StoreTypography } from '@/features/storefronts/_storeBase/typography/StoreTypography'
import { useTranslatable } from '@/localization/useTranslatable'

import styles from './productHero.module.scss'

interface Props {
  product: ProductV2
  ribbons?: Ribbon[]
  enableNewVisuals?: GameId[]
  displayReturnLink?: boolean
}
function GameSpecificHero({ product, ribbons, enableNewVisuals }: Props) {
  switch (product.game) {
    case 'brawlstars':
      return <BrawlPdpProductHero product={product} ribbons={ribbons || []} className={styles.HeroContainer} />
    case 'squadbusters':
      return <SquadPdpProductHero product={product} ribbons={ribbons || []} className={styles.HeroContainer} />
    case 'clashofclans':
      return (
        <ClashPdpProductHero
          product={product}
          ribbons={ribbons || []}
          className={styles.ClashHeroContainer}
          enableNewVisuals={enableNewVisuals}
        />
      )
      return <div />
    case 'clashroyale':
      // Not implemented
      return <div />
    case 'hayday':
      // Not implemented
      return <div />
    default:
      throw new Error('Unsupported game')
  }
}

export const PdpProductHero = ({ product, enableNewVisuals, displayReturnLink }: Props) => {
  const t = useTranslations()
  const translatable = useTranslatable()
  const ribbons = isStoreOfferProduct(product) ? getRibbonsFromTags(product) : []
  return (
    <div className={styles.ProductHeroContainer}>
      {displayReturnLink ? (
        <div className={styles.ReturnContainer}>
          <Link href={`/${product.game}`} className={styles.ReturnLink}>
            <div className={styles.ArrowContainer}>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none">
                <path fill="#000" d="M0 7.071 7.07 0l1.415 1.414-7.071 7.071z" />
                <path fill="#000" d="M7.07 14.143 0 7.07l1.414-1.414 7.071 7.071z" />
                <path fill="#000" d="M15 8H2V6h13z" />
              </svg>
            </div>
            <span className={styles.ReturnLinkLabel}>{t('offers_title')}</span>
          </Link>
        </div>
      ) : null}
      <div className={styles.ProductHeroHeader}>
        <StoreTypography tag="h1" style="outlined" textSize="lg" className={styles.Title}>
          {translatable(product.title)}
        </StoreTypography>
        <PdpProductHeroHeader product={product} />
      </div>
      <div className={cx(styles.ProductHero, styles[product.game])}>
        <GameSpecificHero product={product} ribbons={ribbons} enableNewVisuals={enableNewVisuals} />
      </div>
    </div>
  )
}
